import globalsService from '../services/GlobalsService';

const jsLibRoot = globalsService.getLibRoot();

const constants = {
    languageControlledTags: ['p', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table'],
    inlineElementsThatCannotBeEmpty: ['strong', 'em', 'b', 'i', 'a', 'ul', 'ol'],
    defaultLanguageAttr: 'inspera:defaultLanguage',
    DEFAULT_MATCH_IMAGE_NAME: 'matching_img',
    DEFAULT_MATCH_MIME_TYPE: 'image/png',
    insperaLanguageAttrPrefix: 'inspera:label-lang-',
    supportedFileExtensionsAttr: 'inspera:supportedFileExtenstions',
    supportedLanguagesAttr: 'inspera:supportedLanguages',
    variantAttr: 'inspera:variant',
    allowedIframeAttributes: [
        'name',
        'allow',
        'mozallowfullscreen',
        'webkitallowfullscreen',
        'oallowfullscreen',
        'msallowfullscreen',
    ],

    interactionType: {
        CHOICE_INTERACTION: 'choiceInteraction',
        CUSTOM_INTERACTION: 'customInteraction',
        CUSTOM_INTERACTION_GEOGEBRA: 'customInteractionGeogebra',
        CUSTOM_INTERACTION_ORAL: 'customInteractionOral',
        PORTABLE_CUSTOM_INTERACTION: 'portableCustomInteraction',
        DRAG_AND_DROP_INTERACTION: 'graphicGapMatchInteraction',
        EXTENDED_TEXT_INTERACTION: 'extendedTextInteraction',
        GAP_MATCH_INTERACTION: 'gapMatchInteraction',
        HOTSPOT_INTERACTION: 'hotspotInteraction',
        INLINE_CHOICE_INTERACTION: 'inlineChoiceInteraction',
        MATCH_INTERACTION: 'matchInteraction',
        MATH: 'math',
        NUMERIC_SIMULATIONS: 'numeric-simulations',
        TEXT_ENTRY_INTERACTION: 'textEntryInteraction',
        UPLOAD_INTERACTION: 'uploadInteraction',
        WORD_FORMATION_INTERACTION: 'wordFormationInteraction',
        SYMBOLIC_MATH: 'symbolic-math',
        DRAWING_INTERACTION: 'drawingInteraction',
    },

    objectType: {
        NUMERIC_SIMULATION: 'content_question_qti2_numeric_simulations',
        SYMBOLIC_MATH: 'content_question_qti2_symbolic_math',
        DRAWING: 'content_question_qti2_drawing',
    },

    additionalResourceType: {
        AUDIO: 'audio',
        FILE: 'file',
        LINK: 'link',
        RUBRIC: 'rubric',
        CONTENT_IMAGE: 'content_image',
        EMBEDDED_LINK: 'embeddedLink',
        PCI_TOOL: 'pci_tool',
    },

    extraResponseIdentifiers: {
        CUSTOM_INTERACTION: {
            pngBase64: 'RESPONSE_pngBase64',
        },
        HOTSPOT_INTERACTION: {
            pointer: 'RESPONSE_pointer',
        },
    },

    mediaType: {
        IMAGE: 'image',
        EMBED: 'embed',
        AUDIO: 'audio',
        LINK: 'link',
        PDF: 'application/pdf',
        VIDEO: 'video',
    },

    maxHeightOptions: {
        NONE: 'none',
        RECOMMENDED: 'recommended',
    },

    queryParams: {
        ASSESSMENT_RUN_ID: 'assessmentRunId',
    },

    urlPrefixes: {
        HTTP_PREFIX: ['http://', 'https://'],
    },

    contentAttributes: {
        LOGICAL_NAME: 'inspera:logicalName',
        LOGICAL_NAME_DATA: 'data-logicalname',
        OBJECT_TYPE: 'inspera:objectType',
        CONTENT_ITEM_ID: 'data-contentitemid',
    },

    staticLibPaths: {
        ACEEDITOR: `${jsLibRoot}/lib/ace/1.4.1/`,
        CKEDITOR_LATEST: `${jsLibRoot}/lib/ckeditor/4.16.0_01/`,
        DEVELOPMENT_PDF: `${jsLibRoot}/lib/pdfjs/fallback.pdf`,
        HYPOTHESIS: `${jsLibRoot}/lib/player-annotate/0.0.43/build/boot.js`,
        MATHJAX2: `${jsLibRoot}/lib/mathjax/2.7.9/`,
        MATHJAX3: `${jsLibRoot}/lib/mathjax/3.1.2/`,
        MEDIA_RECORDER_POLYFILL: `${jsLibRoot}/lib/audio-recorder-polyfill/polyfill-media-recorder.js`,
        MOMENT_TIMEZONE: `${jsLibRoot}/lib/moment-timezone/0.5.14-2017c/`,
        MOMENT: `${jsLibRoot}/lib/moment/2.19.2/`,
        PCI_COMMUNICATION_BRIDGE: `${jsLibRoot}/lib/pci/communication-bridge/1.0.2/pciCommunicationBridge.js`,
        PDFJS_ROOT: `${jsLibRoot}/lib/pdfjs/2.6.347_9/`,
        PDFJS: `${jsLibRoot}/lib/pdfjs/2.6.347_9/web/viewer.html`,
        REQUIREJS: `${jsLibRoot}/lib/pci/require/1.7.2_no_js_suffix/require-jquery.js`,
        TALVIEW_SCRIPT: 'https://cdn.proview.io/client/init.js',
        WEBSPELLCHECKER_WEB_LATEST: `${jsLibRoot}/lib/webspellchecker/5.10.0.0_4/`,
    },

    staticLibPathsOffline: {
        CKEDITOR: 'lib/ckeditor/',
        ACEEDITOR: '',
        MATHJAX2: 'lib/mathjax/',
        MATHJAX3: 'lib/mathjax3/',
        GEOGEBRA: '',
    },

    componentContexts: {
        EXAM: 'exam',
        PRELOAD: 'preload',
        PREVIEW: 'preview',
        PREVIEW_DRAFT: 'previewDraft',
        VIEW_DELIVERY: 'viewDelivery',
        VIEW_GRADING_QUESTION_DELIVERY: 'viewGradingQuestionDelivery',
        VIEW_GRADING_QUESTION_PREVIEW: 'viewGradingQuestionPreview',
        VIEW_OWN_DELIVERY: 'viewOwnDelivery',
    },

    keyCodes: {
        SHIFT: 16,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        BACKSPACE: 8,
        DELETE: 46,
        ESCAPE: 27,
        SPACE: 32,
        DIGIT1: 49,
        DIGIT2: 50,
        DIGIT3: 51,
        DIGIT4: 52,
    },

    keyCodeStepSizeMap: {
        // DIGIT1
        49: 1,
        // DIGIT2
        50: 20,
        // DIGIT3
        51: 80,
        // DIGIT4
        52: 160,
    },

    arrowKeyCodes: {
        37: 'LEFT',
        38: 'UP',
        39: 'RIGHT',
        40: 'DOWN',
    },

    allowedKeyCodesNumericInput: {
        ALT: 18,
        BACKSPACE_KEY: 8,
        CAPS: 20,
        CTRL: 17,
        DELETE_KEY: 46,
        ENTER: 13,
        ESC: 27,
        LEFT_KEY: 37,
        RIGHT_KEY: 39,
        SHIFT: 16,
        TAB_KEY: 9,
    },

    // Home and End key codes for cursor navigation
    // Usage is gated by A11Y_ITERATION_FOR_IIB_SCREEN_READER v4 in TextEntryNumericInput
    navigationKeyCodes: {
        HOME_KEY: 36,
        END_KEY: 35,
    },

    editorToolbarModes: {
        DEFAULT: 'default',
        BASIC: 'basic',
    },

    itemSessionStatuses: {
        INITIAL: 'initial',
        INTERACTING: 'interacting',
        MODAL_FEEDBACK: 'modal feedback',
        SUSPENDED: 'suspended',
        CLOSED: 'closed',
        SOLUTION: 'solution',
        REVIEW: 'review',
    },

    pciMessage: {
        INIT: 'PCI_INIT',
        MODULE_LOADED: 'PCI_MODULE_LOADED',
        GET_INSTANCE: 'PCI_GET_INSTANCE',
        ON_READY: 'PCI_ON_READY',
        ON_DONE: 'PCI_ON_DONE',
        RECEIVE_RESPONSE_AND_STATE: 'PCI_RECEIVE_RESPONSE_AND_STATE',
        DO_COMPLETED: 'PCI_DO_COMPLETED',
        REQUEST_RESPONSE_AND_STATE: 'PCI_REQUEST_RESPONSE_AND_STATE',
        MODULE_LOAD_ERROR: 'PCI_MODULE_LOAD_ERROR',
    },

    pciCardinality: {
        BASE: 'base',
        LIST: 'list',
    },

    baseTypes: {
        BOOLEAN: 'boolean',
        INTEGER: 'integer',
        FLOAT: 'float',
        STRING: 'string',
        POINT: 'point',
        PAIR: 'pair',
        DIRECTED_PAIR: 'directedPair',
        DURATION: 'duration',
        FILE: 'file',
        URI: 'uri',
        INT_OR_IDENTIFIER: 'intOrIdentifier',
        IDENTIFIER: 'identifier',
    },

    qtiCardinality: {
        MULTIPLE: 'multiple',
        SINGLE: 'single',
    },

    autoFeedbackNames: {
        ANSWERED: 'feedback_answered',
        CORRECT: 'feedback_correct',
        PARTIALLY_CORRECT: 'feedback_partially_correct',
        UNANSWERED: 'feedback_unanswered',
        WRONG: 'feedback_wrong',
    },

    modalFeedbackKey: 'FEEDBACK',

    noChoiceMadeOption: 'no_choice_made',

    // Animation duration for Navigation between feedbacks
    // Files to check:
    // FeedbackNavigationButton.js -> `navigationHandler` function
    // QuestionDisplay.scss -> `.highlightInteractionWrapper` class
    animationDuration: 2300,

    dynamicMathOperators: {
        ABSOLUTE: 'absolute',
        RELATIVE: 'relative',
        EXACT: 'exact',
        ALGEBRAIC_EQUIVALENCE: 'algebraicEquivalence',
        STRING_MATCH: 'stringMatch',
        GT: 'gt',
        LT: 'lt',
        NOT: 'not',
    },

    selectionType: {
        YES: 'YES',
        NO: 'NO',
        UNDECIDED: 'UNDECIDED',
    },
    SUPPORTED_NAV_KEYS_FOR_QUESTION_IN_SECTIONS: {
        ARROW_RIGHT: 'ArrowRight',
        ARROW_LEFT: 'ArrowLeft',
        HOME: 'Home',
        END: 'End',
    },
};

export default constants;
